// The Pricing Approval guide (35_PricingApproval.jsx · ModuleHelp, Max 01/11).
const en = {
  tabsT: 'Where the quote stands',
  tabsB: 'A quote moves through Pending (drafts and quotes sent back), the sales manager, the CEO, then Approved. The number on each tab is how many quotes are in that stage.',
  toolbarT: 'Count and scope',
  toolbarB: 'Shows how many quotes are listed. If you cover more than one team, the team filter narrows the list; ticking rows adds a bar for approving several at once.',
  listT: 'The quotes',
  listB: 'One row per quote with who submitted it, who decided and the notes they left. Click the quote ID or its name to open the whole quote.',
  actionsT: 'What you can do',
  actionsB: 'The buttons in the Action column depend on the stage and on your role, for example submit, recall, approve or reject. Approve and reject ask for a note first.',
};
const ko = {
  tabsT: '견적의 진행 단계',
  tabsB: '견적은 작성 중(초안과 반려된 견적), 영업 매니저, CEO, 승인 완료 순으로 진행됩니다. 각 탭의 숫자는 해당 단계의 견적 수입니다.',
  toolbarT: '건수와 범위',
  toolbarB: '목록에 있는 견적 수를 보여 줍니다. 여러 팀을 담당한다면 팀 필터로 목록을 좁힐 수 있고, 행을 체크하면 한 번에 승인하는 바가 나타납니다.',
  listT: '견적 목록',
  listB: '견적당 한 행이며 제출자, 결정자, 남긴 메모가 함께 보입니다. 견적 ID나 이름을 누르면 견적 전체가 열립니다.',
  actionsT: '할 수 있는 작업',
  actionsB: '작업 열의 버튼은 단계와 역할에 따라 다르며, 제출, 회수, 승인, 반려 등이 있습니다. 승인과 반려는 먼저 메모를 입력하게 합니다.',
};
const vi = {
  tabsT: 'Báo giá đang ở bước nào',
  tabsB: 'Báo giá đi qua Pending (bản nháp và báo giá bị trả lại), sales manager, CEO rồi đến Approved. Con số trên mỗi tab là số báo giá đang ở bước đó.',
  toolbarT: 'Số lượng và phạm vi',
  toolbarB: 'Cho biết đang liệt kê bao nhiêu báo giá. Nếu bạn phụ trách nhiều team, bộ lọc team sẽ thu hẹp danh sách; tick chọn các dòng thì có thanh duyệt nhiều báo giá cùng lúc.',
  listT: 'Danh sách báo giá',
  listB: 'Mỗi báo giá một dòng, kèm người gửi, người quyết định và ghi chú của họ. Bấm vào mã báo giá hoặc tên để mở toàn bộ báo giá.',
  actionsT: 'Việc bạn có thể làm',
  actionsB: 'Các nút ở cột Thao tác tùy theo bước và vai trò của bạn, ví dụ gửi duyệt, thu hồi, duyệt hoặc từ chối. Duyệt và từ chối đều yêu cầu nhập ghi chú trước.',
};
const zh = {
  tabsT: '报价所处的阶段',
  tabsB: '报价依次经过 Pending（草稿和被退回的报价）、销售经理、CEO，最后是 Approved。每个标签页上的数字是该阶段的报价数量。',
  toolbarT: '数量与范围',
  toolbarB: '显示当前列出的报价数量。如果您负责多个团队，可用团队筛选缩小列表；勾选行后会出现批量审批栏。',
  listT: '报价列表',
  listB: '每份报价一行，并显示提交人、决定人和他们留下的备注。点击报价编号或名称即可打开整份报价。',
  actionsT: '您能做什么',
  actionsB: '“操作”列中的按钮取决于阶段和您的角色，例如提交、撤回、批准或退回。批准和退回都会先要求填写备注。',
};
// French and Japanese (task #1173, 2026-11-04) — generated from `en`; a string not yet translated reads English.
const fr = {
  "tabsT": "Où en est le devis",
  "tabsB": "Un devis passe par En attente (brouillons et devis renvoyés), le responsable des ventes, le CEO, puis Approuvé. Le nombre sur chaque onglet indique combien de devis se trouvent à cette étape.",
  "toolbarT": "Nombre et périmètre",
  "toolbarB": "Indique combien de devis sont listés. Si vous couvrez plus d'une équipe, le filtre d'équipe affine la liste ; cocher des lignes ajoute une barre pour approuver plusieurs devis à la fois.",
  "listT": "Les devis",
  "listB": "Une ligne par devis avec la personne qui l'a soumis, celle qui a décidé et les notes laissées. Cliquez sur l'ID du devis ou son nom pour ouvrir le devis complet.",
  "actionsT": "Ce que vous pouvez faire",
  "actionsB": "Les boutons de la colonne Action dépendent de l'étape et de votre rôle, par exemple soumettre, rappeler, approuver ou rejeter. Approuver et rejeter demandent d'abord une note."
};
const ja = {
  "tabsT": "見積の進行状況",
  "tabsB": "見積は「保留中」（下書きと差し戻された見積）、セールスマネージャー、CEO を経て 「承認済み」になります。各タブの数字は、その段階にある見積の件数です。",
  "toolbarT": "件数と範囲",
  "toolbarB": "リストされている見積の件数を表示します。複数のチームを担当している場合は、チームフィルターでリストを絞り込めます。行にチェックを入れると、複数をまとめて承認するバーが表示されます。",
  "listT": "見積",
  "listB": "見積ごとに1行で、提出者、判断した人、残されたメモを表示します。見積 ID または名前をクリックすると、見積全体が開きます。",
  "actionsT": "できること",
  "actionsB": "「操作」列のボタンは、段階とあなたのロールによって異なります（例：提出、取り下げ、承認、却下）。承認と却下では、先にメモの入力が求められます。"
};

const dictionary = { ns: 'tourPricingApproval', en, ko, vi, zh, fr, ja };
export default dictionary;
